// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1j-0";